const lentaStories = [
    {
        image: require('./images/lenta/stories-animation/1.png'),
    },
    {
        image: require('./images/lenta/stories-animation/2.png'),
    },
    {
        image: require('./images/lenta/stories-animation/3.png'),
    },
    {
        image: require('./images/lenta/stories-animation/4.png'),
    },
    {
        image: require('./images/lenta/stories-animation/5.png'),
    },
    {
        image: require('./images/lenta/stories-animation/6.png'),
    },
];
export default lentaStories;